
import React, { useState ,useEffect} from "react";
import axios from 'axios';
import { Container, Row, Col, Button, Input, InputGroup, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CandidateDataInfo from './OrgListDataInfo'
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import Swal from "sweetalert2";

import { FaBriefcase, FaRegPlusSquare, FaPhoneAlt, FaExternalLinkAlt, FaRegEye, FaRegEdit } from "react-icons/fa";
import { Tr } from "react-super-responsive-table";

const OrganizationList = () => {
    const [CandidateListData, setCandidateListData] = useState(CandidateDataInfo);
    const [selectedCandidates, setselectedCandidates] = useState([]);
    const [expandedJobRows, setExpandedJobRows] = useState(null);

    const [loading, setLoading] = useState(true);
    const [postingDesc, setPostingDesc] = useState(false);

const postCompanyDescription = async () => {
    if (!companyDesc?.trim()) {
        Swal.fire({
            icon: "warning",
            title: "Validation Error",
            text: "Description cannot be empty",
        });
        return;
    }

    setPostingDesc(true);

    try {
        const payload = {
            description: companyDesc,
            company_id: selectedCompany?.company_id,
        };

        const res = await axios.post(
            "/api/v1/company-description/",
            payload
        );

        setCompanyData((prev) =>
            prev.map((item) =>
                item.company_id === selectedCompany.company_id
                    ? { ...item, company_description: companyDesc }
                    : item
            )
        );

        Swal.fire({
            icon: "success",
            title: "Saved Successfully",
            text: "Company description has Added Successfully.",
            timer: 2000,
            showConfirmButton: false,
        });

        setEditDescModal(false);
        setCompanyDesc("");
        setSelectedCompany(null);
    } catch (error) {
        console.error("Failed to post description", error);

        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong while saving the description.",
        });
    } finally {
        setPostingDesc(false);
    }
};




    const [backdrop, setBackdrop] = useState(true);
    const [keyboard, setKeyboard] = useState(true);
    const [editDescModal, setEditDescModal] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companyDesc, setCompanyDesc] = useState("");
    const toggleEditDescModal = () => setEditDescModal(!editDescModal);
    const companyDescriptionTemplate = (rowData) => {
    return (
        <span className="text-truncate d-block" style={{ maxWidth: "350px" }} title={rowData.company_description || "-"}>
            {rowData.company_description || "-"}
        </span>
    );
};
const actionTemplate = (rowData) => {
    return (
        <Button
            color="link"
            className="p-0 text-dark"
            title="Edit Company Description"
            onClick={() => {
                setSelectedCompany(rowData); 
                setCompanyDesc(rowData.company_description || "");
                setEditDescModal(true);
            }}
        >
            <FaRegEdit size={16} />
        </Button>
    );
};

    const changeBackdrop = (e) => {
        let { value } = e.target;
        if (value !== 'static') {
            value = JSON.parse(value);
        }
        setBackdrop(value);
    };

    const changeKeyboard = (e) => {
        setKeyboard(e.currentTarget.checked);
    };

    const viewCandidateExperience = (rowData) => {
        return (
            <span className="bg-light px-2 py-1 rounded d-inline-block">
                {rowData.experience} + Years
            </span>
        );
    };

    const viewCandidateDetails = (rowData) => {
        return (
            <Button className="btn btn-light" onClick={ViewCandidateInfoCall}><FaRegEye /></Button>
        )
    }

    const [ViewCandidatePopupShow, setViewCandidatePopupShow] = useState(false);

    const ViewCandidateInfoCall = () => { setViewCandidatePopupShow(!ViewCandidatePopupShow); }

    const [companyData, setCompanyData] = useState([]);
       const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    console.log(userInfos, "userInfosuserInfosuserInfos");
    const companyId = userInfos.user_details.companies_data[0].company_id;

    const getCompanyDetails = async () => {
        console.log(companyData, "companyData");
        setLoading(true);
        try {
            const response = await axios.get(`api/v1/companyv1`);
            const response_data = response.data.message
            if (response_data) {
                const normalizedData = response_data.map((item) => ({
                ...item,
                company_description: item.description || "", 
            }));
                setCompanyData(normalizedData)
                setLoading(false);

            } else {
               setLoading(false);
            }
        } catch (error) {
           setLoading(false); 
        }
    }

    useEffect(() => {
        getCompanyDetails()
    }, [])


    return (
        <React.Fragment>
            <div className="page-content allact-tabs manager-dash">
                <Container fluid>
                    <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
                        <Card className="mb-3 shadow-md border-0">           
                            {loading ? (
                                <OrgTableShimmer columns={6} rows={7} titleWidth="170px" />
                            ) : (
                                <Row >
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}> <h1 class="page-title mb-1">Companies List</h1> </Col>
                                    <Col xxl={12}>
                                        <DataTable
                                            className="OrganizationTableView"
                                            value={companyData}
                                            dataKey="id"
                                            scrollHeight="500px"
                                            scrollable
                                            id="AllEmployees_TableView"
                                            // tableStyle={{ minWidth: "50rem" }}
                                            paginator rows={8}
                                            responsiveLayout="scroll"
                                        // selectionMode="checkbox" selection={selectedCandidates}  onSelectionChange={(e) => setselectedCandidates(e.value)}
                                        // expandedRows={expandedJobRows} onRowToggle={(e) => setExpandedJobRows(e.data)}
                                        >
                                            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                                            {/* <Column expander style={{ width: "3rem" }} /> */}
                                            <Column field="company_name" header="Company Name " />
                                            <Column field="company_domain" header="Company Domain" />
                                            {/* <Column field="company_email" header="Email" body="-"/> */}
                                            {/* <Column field="mobile_phone" header="Mobile/Phone"  body="-" /> */}
                                            <Column field="company_type" header="Company Type" />
                                            {/* <Column field="company_size" header="Company Size"  body="-"/> */}
                                            <Column field="created_at" header="Created At" />
                                            <Column
                                                header="Company Description"
                                                // style={{ maxWidth: "350px" }}
                                                body={companyDescriptionTemplate}
                                            />
                                            <Column
                                                header="Action"
                                                body={actionTemplate}
                                                style={{ width: "100px", textAlign: "center" }}
                                            />

                                            {/* <Column field="company_owner" header="Company Owner"  body="-"/> */}



                                            {/* <Column field="experience" header="Experience" body={viewCandidateExperience} />
                                            <Column header="Candidate Details" body={viewCandidateDetails} />
                                            <Column field="actionStatus" header="Assigned Tests" />
                                            <Column field="actionStatus" header="Is Selected" />
                                            <Column
                                                header="Action"
                                                body={() => (
                                                    <div className="d-flex gap-2">
                                                        <Button color="success" size="sm">
                                                            delete
                                                        </Button>
                                                    </div>
                                                )}
                                            /> */}
                                        </DataTable>
                                    </Col>
                                </Row>
                            )}  
                        </Card> 
                    </div>
                </Container>
            </div>
            <Modal isOpen={ViewCandidatePopupShow} toggle={ViewCandidateInfoCall} size="xl" backdrop={backdrop} keyboard={keyboard}>
                <ModalHeader toggle={ViewCandidateInfoCall}></ModalHeader>
                <ModalBody>
                    <Card title="Candidate Analysis" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>First Name</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}></Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Last Name</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}></Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Total Experience</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>0.0</Col>
                        </Row>
                    </Card>

                    <Card title="Contact Info" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>Email</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>@gmail.com</Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Phone</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}></Col>
                        </Row>
                    </Card>

                    <Card title="Skills" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>Skills</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>Python, Django,</Col>
                        </Row>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="warning" onClick={ViewCandidateInfoCall}>Cancel</Button>
                </ModalFooter>
            </Modal>
            {/* <Modal isOpen={editDescModal} toggle={toggleEditDescModal} centered>
                    <ModalHeader toggle={toggleEditDescModal}>
                        Add Company Description
                    </ModalHeader>

                    <ModalBody>
                        <div className="mb-2">
                            <strong>Company :</strong>{" "}
                            {selectedCompany?.company_name}
                        </div>

                        <Input
                            type="textarea"
                            rows="5"
                            placeholder="Enter company description..."
                            value={companyDesc}
                            onChange={(e) => setCompanyDesc(e.target.value)}
                        />
                        <strong>Note : </strong><span>This content will be used for a LinkedIn post.</span>
                    </ModalBody>

                    <ModalFooter className="justify-content-center">
                        <Button
                            color="secondary"
                            onClick={toggleEditDescModal}
                        >
                            Cancel
                        </Button>

                       <Button
                    color="primary"
                    disabled={postingDesc}
                    onClick={postCompanyDescription}
                >
                    {postingDesc ? "Saving..." : "Save"}
                </Button>


                    </ModalFooter>
                </Modal> */}
                <Modal 
    isOpen={editDescModal} 
    toggle={!postingDesc ? toggleEditDescModal : undefined} 
    centered
    backdrop={postingDesc ? "static" : true}   // prevents closing by clicking outside
    keyboard={!postingDesc}                    // prevents ESC key close
>
    <ModalHeader
        toggle={!postingDesc ? toggleEditDescModal : undefined}
    >
        Add Company Description
    </ModalHeader>

    <ModalBody>
        <div className="mb-2">
            <strong>Company :</strong> {selectedCompany?.company_name}
        </div>

        <Input
            type="textarea"
            rows="5"
            placeholder="Enter company description..."
            value={companyDesc}
            onChange={(e) => setCompanyDesc(e.target.value)}
            disabled={postingDesc}
        />
        <strong>Note : </strong>
        <span>This content will be used for a LinkedIn post.</span>
    </ModalBody>

    <ModalFooter className="justify-content-center">

        {/* Cancel button disabled while saving */}
        <Button
            color="secondary"
            disabled={postingDesc}
            onClick={toggleEditDescModal}
        >
            Cancel
        </Button>

        <Button
            color="primary"
            disabled={postingDesc}
            onClick={postCompanyDescription}
        >
            {postingDesc ? "Saving..." : "Save"}
        </Button>
    </ModalFooter>
</Modal>

        </React.Fragment>
    )
}

export default OrganizationList;
